import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import messages from '../../intl/messages';
import { hideModal } from '../../store/modal/actions';
import { deleteExams } from '../../store/model/actions';
import SaveCloseModalTemplate from './SaveCloseModalTemplate';

const RemoveExamsModal = ({ examIds, clearSelectionModel }) => {
	const intl = useIntl();
	const dispatch = useDispatch();

	return (
		<SaveCloseModalTemplate
			title={<FormattedMessage {...messages.removeExams} />}
			saveBtnTitle={<FormattedMessage {...messages.removeExams} />}
			onSave={() => {
				dispatch(deleteExams(examIds, intl));
				dispatch(hideModal());
				clearSelectionModel();
			}}
		>
			<FormattedMessage {...messages.sureToRemoveExams} />
		</SaveCloseModalTemplate>
	);
};

export default RemoveExamsModal;
